import { createContext, useContext, useState, useEffect } from "react";
import { unitPriceForQty } from "@/lib/pricing";

const CartContext = createContext(null);
const KEY = "luxe_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { /* storage blocked (iframe/Safari ITP) */ }
  }, [items]);

  const addItem = (product, qty = 1) => {
    const onSale = product.sale_price && product.sale_price > 0 && product.sale_price < product.price;
    const price = onSale ? product.sale_price : product.price;
    setItems((prev) => {
      const found = prev.find((i) => i.id === product.id);
      if (found) {
        return prev.map((i) => i.id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        id: product.id, name: product.name, price: price,
        tier_prices: product.tier_prices || [],
        image: product.images?.[0] || "", quantity: qty,
      }];
    });
    setIsOpen(true);
  };

  const updateQty = (id, qty) => {
    if (qty < 1) return removeItem(id);
    setItems((prev) => prev.map((i) => i.id === id ? { ...i, quantity: qty } : i));
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clearCart = () => setItems([]);
  const openCart = () => setIsOpen(true);
  const closeCart = () => setIsOpen(false);

  const pricedItems = items.map((i) => ({ ...i, unit_price: unitPriceForQty(i.price, i.tier_prices, i.quantity) }));
  const count = pricedItems.reduce((s, i) => s + i.quantity, 0);
  const total = pricedItems.reduce((s, i) => s + i.unit_price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items: pricedItems, addItem, updateQty, removeItem, clearCart, count, total, isOpen, openCart, closeCart }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
